// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import { InternalTableBodyCell } from './internal';
function TableBodyCell(props) {
    const { __internalRootRef } = useBaseComponent('TableBodyCell', {
        props: { disablePaddings: props.disablePaddings, isRowHeader: props.isRowHeader, colSpan: props.colSpan },
    });
    const { isRowHeader, ...rest } = props;
    return React.createElement(InternalTableBodyCell, { ...rest, tag: isRowHeader ? 'th' : 'td', ref: __internalRootRef });
}
applyDisplayName(TableBodyCell, 'TableBodyCell');
export default TableBodyCell;
//# sourceMappingURL=index.js.map